<script setup lang="ts">
import { ref } from 'vue'
import BsTabs from '@/legacy/components/Tabs.vue'
import BsTab from '@/legacy/components/Tab.vue'

defineProps({
	isPrivate: {
		type: Boolean,
		default: false,
	},
	tabList: {
		type: Object,
		require: true,
	},
})

const currentTab = ref('posts')
</script>

<template>
	<div class="bs-product-sharing-tabs">
		<bs-tabs v-cloak :cust-per-page="4" :disable-wrap-width="true">
			<bs-tab
				v-for="tab in tabList"
				:key="tab.id"
				:isUnderline="currentTab === tab.id"
				@click="currentTab = tab.id"
			>
				<i
					:class="{
						'icon-posts': tab.id === 'posts',
					}"
				></i>
				<div class="bs-tab-desc text-subtitle-sm">{{ tab.name }}</div>
			</bs-tab>
		</bs-tabs>
	</div>
</template>
